(function () {
  let countdownTimer = null;

  const parseCountdownEnd = (raw, timezone) => {
    const value = (raw || "").trim();
    if (!value) return null;

    if (/[zZ]$|[+-]\d{2}:?\d{2}$/.test(value)) {
      const parsed = Date.parse(value.includes("T") ? value : value.replace(" ", "T"));
      return Number.isNaN(parsed) ? null : parsed;
    }

    let normalized = value.replace(" ", "T");
    if (/^\d{4}-\d{2}-\d{2}$/.test(normalized)) normalized += "T23:59:59";
    else if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(normalized)) normalized += ":00";
    else if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/.test(normalized)) return null;

    const match = /^([+-])(\d{2})(\d{2})$/.exec(timezone || "");
    const offset = match ? `${match[1]}${match[2]}:${match[3]}` : "Z";
    const parsed = Date.parse(`${normalized}${offset}`);
    return Number.isNaN(parsed) ? null : parsed;
  };

  const paintCountdown = (el, remaining) => {
    const totalSeconds = Math.max(0, Math.floor(remaining / 1000));
    const parts = {
      days: Math.floor(totalSeconds / 86400),
      hours: Math.floor((totalSeconds % 86400) / 3600),
      minutes: Math.floor((totalSeconds % 3600) / 60),
      seconds: totalSeconds % 60,
    };

    Object.entries(parts).forEach(([name, value]) => {
      const node = el.querySelector(`[data-countdown-${name}]`);
      if (node) node.textContent = String(value).padStart(2, "0");
    });
  };

  const initCountdown = () => {
    if (countdownTimer) {
      clearInterval(countdownTimer);
      countdownTimer = null;
    }

    const states = [...document.querySelectorAll("[data-announcement-countdown]")]
      .map((el) => {
        const end = parseCountdownEnd(el.dataset.countdownEnd, el.dataset.timezone);
        if (!end) el.hidden = true;
        return { el, end, done: !end };
      })
      .filter((state) => state.end);

    if (!states.length) return;

    const tick = () => {
      const now = Date.now();
      let active = false;

      states.forEach((state) => {
        if (state.done) return;
        const remaining = state.end - now;
        paintCountdown(state.el, remaining);
        if (remaining <= 0) state.done = true;
        else active = true;
      });

      if (!active && countdownTimer) {
        clearInterval(countdownTimer);
        countdownTimer = null;
      }
    };

    tick();
    if (states.some((state) => !state.done)) {
      countdownTimer = setInterval(tick, 1000);
    }
  };

  const initAnnBar = () => {
    const annBar = document.querySelector(".section-announcement");
    initCountdown();

    let observer;
    const createObserver = () => {
      if (observer) observer.disconnect();
      observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const annBarHeight = annBar?.getBoundingClientRect().height || 0;
              document.documentElement.style.setProperty(
                "--ann-height",
                `${(annBarHeight * entry.intersectionRatio).toFixed(2)}px`
              );
            } else {
              document.documentElement.style.setProperty("--ann-height", "0px");
            }
          });
        },
        {
          threshold: Array.from({ length: 1000 }, (_, i) => i / 1000),
        }
      );

      if (annBar) observer.observe(annBar);
    };
    createObserver();
  };

  document.addEventListener("shopify:section:load", initAnnBar);
  document.addEventListener("shopify:section:unload", initAnnBar);
  document.addEventListener("shopify:section:reorder", initAnnBar);

  initAnnBar();
})();
